import { createFileRoute } from '@tanstack/react-router'
import { ExpensePage } from '../../../../components/ExpensePage'

export const Route = createFileRoute('/$org/expenses/$expenseUid/edit')({
  component: ExpenseDetail,
})

function ExpenseDetail() {
  return <ExpensePage />
}
